import React from 'react';
import { motion } from 'framer-motion';
import { Mountain, BookOpen, MessageSquare, MapPin } from 'lucide-react';
const pillars = [{
  icon: <Mountain size={24} className="text-white" data-id="element-192" />,
  title: 'De acá',
  desc: 'El contexto no se aprende en un curso.'
}, {
  icon: <BookOpen size={24} className="text-white" data-id="element-193" />,
  title: 'Formados',
  desc: 'Marketing, diseño y datos actualizados.'
}, {
  icon: <MessageSquare size={24} className="text-white" data-id="element-194" />,
  title: 'Claros',
  desc: 'Explicamos todo sin jerga técnica.'
}, {
  icon: <MapPin size={24} className="text-white" data-id="element-195" />,
  title: 'Presentes',
  desc: 'Respondemos cuando nos necesitás.'
}];
export function WhoWeAre() {
  return <section id="nosotros" className="py-20 md:py-32 bg-arena px-5 md:px-8" data-id="element-196">
      <div className="max-w-[1180px] mx-auto" data-id="element-197">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mb-20" data-id="element-198">
          {/* Left: Text */}
          <div data-id="element-199">
            <motion.span initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-terracota font-nunito text-sm uppercase tracking-[0.1em] font-bold block mb-4" data-id="element-200">
              Quiénes somos
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-negro mb-8 leading-tight" data-id="element-201">
              Nacimos en la Quebrada.
              <br data-id="element-202" />
              Trabajamos para los de la Quebrada.
            </motion.h2>

            <div className="space-y-5 text-negro/70 font-nunito text-lg" data-id="element-203">
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} data-id="element-204">
                Somos dos amigos de la Quebrada. Como cualquiera de acá, vimos
                crecer negocios con mucho esfuerzo y poca visibilidad.
              </motion.p>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} data-id="element-205">
                Y también vimos cómo llegaban de afuera prometiendo soluciones
                que terminaban en fotos mal sacadas, plata mal gastada y
                clientes más confundidos que antes.
              </motion.p>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} data-id="element-206">
                Nos cansamos. Decidimos hacer algo. Nos capacitamos en
                marketing, diseño y herramientas digitales. No para impresionar.
                Para hacer bien lo que veíamos que se hacía mal.
              </motion.p>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5
            }} data-id="element-207">
                No venimos a volvernos imprescindibles. Venimos a que entiendas
                cada decisión, cada peso invertido y cada resultado.
              </motion.p>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.6
            }} className="font-bold text-terracota text-xl pt-2" data-id="element-208">
                Quebrada Digital nació de acá, para acá.
              </motion.p>
            </div>
          </div>

          {/* Right: Visual Placeholder */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full aspect-[4/5] rounded-[16px] bg-negro shadow-warm overflow-hidden" data-id="element-209">
            <img src="https://cdn.magicpatterns.com/uploads/7gNkVD62Rumw6cxpvkuzGg/FOTOGRUPAL_QD.png" alt="El equipo de Quebrada Digital en la Quebrada de Humahuaca" className="w-full h-full object-cover" data-id="element-210" />
          </motion.div>
        </div>

        {/* 4 Value Pillars */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-211">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1 * index
        }} className="flex flex-col items-center text-center" data-id="element-212">
              <div className="w-16 h-16 rounded-full bg-terracota flex items-center justify-center mb-5 shadow-sm" data-id="element-213">
                {pillar.icon}
              </div>
              <h3 className="font-playfair font-bold text-negro text-xl mb-2" data-id="element-214">
                {pillar.title}
              </h3>
              <p className="font-nunito text-negro/60 text-sm leading-relaxed max-w-[200px]" data-id="element-215">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}